var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "label-width": "80px",
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          searchBtnHide: !!_vm.$store.getters.cusId,
          resetBtnHide: !!_vm.$store.getters.cusId,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u(
          [
            !_vm.$store.getters.cusId
              ? {
                  key: "baseForm",
                  fn: function () {
                    return undefined
                  },
                  proxy: true,
                }
              : null,
            {
              key: "tableOperation",
              fn: function () {
                return [
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "main-btn",
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.handleOpen()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("addText")))]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "tableColumn",
              fn: function () {
                return [
                  _vm._l(_vm.dropCols, function (col, index) {
                    return [
                      col.prop !== "bjTableAction"
                        ? _c("el-table-column", {
                            key:
                              "col_" +
                              index +
                              "_" +
                              col.prop +
                              "_" +
                              (col.width || "auto"),
                            attrs: {
                              prop: col.prop,
                              label: col.label,
                              width: col.width || "auto",
                              fixed: col.fixed || false,
                              align: "center",
                              "class-name": "item",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      false
                                        ? void 0
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeFilters")(
                                                  scope.row[col.prop],
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                      col.prop === "bjTableAction"
                        ? _c("el-table-column", {
                            key:
                              "col_" +
                              index +
                              "_" +
                              col.prop +
                              "_" +
                              (col.width || "auto"),
                            attrs: {
                              prop: col.prop,
                              label: col.label,
                              width: col.width || "auto",
                              fixed: col.fixed || "right",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "edit-btn",
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleOpen(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("editText")))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                    ]
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.title,
            visible: _vm.addDialogVisible,
            width: "500px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("billingPage.name"), prop: "name" } },
                [
                  _c("BjInput", {
                    attrs: { maxlength: 20, placeholder: _vm.$t("inputText") },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("billingPage.code"), prop: "code" } },
                [
                  _c("BjInput", {
                    attrs: { maxlength: 20, placeholder: _vm.$t("inputText") },
                    model: {
                      value: _vm.form.code,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "code", $$v)
                      },
                      expression: "form.code",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("form")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }